import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { FormattedAmount } from "vino/core";
import Image from "vino/components/Image";
import Typography from "@mui/material/Typography";

const OrderProductListItem = ({ orderItem }) => {
	const { quantity, variant } = orderItem;

	const { product } = variant;

	return (
		<TableRow>
			<TableCell>
				<div className="flex justify-between">
					<Image
						className="w-40 h-full rounded-16 block mr-5"
						image={product}
					/>

					<div className="flex flex-1 flex-col relative overflow-hidden px-8">
						{product.name}
						<Typography color="textSecondary">{variant.name}</Typography>
					</div>
				</div>
			</TableCell>
			<TableCell align="right">
				<FormattedAmount value={variant.price} fixedDecimalScale={true} />
			</TableCell>
			<TableCell align="right">{quantity}</TableCell>
			<TableCell align="right">
				<FormattedAmount
					value={quantity * variant.price}
					fixedDecimalScale={true}
				/>
			</TableCell>
		</TableRow>
	);
};

export default OrderProductListItem;
